import HomePurchaseText from "../text/home_purchase_text";
import replaceTextInString from "../../../objects/CommonUse/replace_text_in_string";

export const determineHomeErrorText = (textType, replaceString, replaceValue) => {
    let homePurchaseText = HomePurchaseText.textTable;
    let textObj = {text: textType, errorType: "critical"};
    textObj =  homePurchaseText.find(elem => elem.textType === textType);
    if (textObj.text.includes("||")){
        let replaceObj = { string: replaceValue };
        textObj.text =
            replaceTextInString(textObj.text, replaceObj, replaceString, "string")
    }
    return textObj;
}
export default determineHomeErrorText;